<script setup lang="ts">
import { ref } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  marketType,
  getValue,
  getPercentageValue,
  getValueTrend,
} from "~/helpers/live-market";
import { useLiveMarketData } from "~/composables/useLiveMarketData";

const scrollableArea = ref<HTMLDivElement | null>(null);
const currentItem = ref(0);
const currentMarketData = ref([]);

const data = await useLiveMarketData();

currentMarketData.value = data.value[marketType[currentItem.value].key];

watch(currentItem, (newCurrentItem) => {
  currentMarketData.value = data.value[marketType[newCurrentItem].key];
});

function scrollLeft() {
  scrollableArea?.value?.scrollBy(-120, 0);
}

function scrollRight() {
  scrollableArea?.value?.scrollBy(120, 0);
}
</script>

<template>
  <div class="live-market-data">
    <div class="nav-market-wrapper">
      <div class="nav-market-control left" @click="scrollLeft">
        <FontAwesomeIcon :icon="faChevronLeft" />
      </div>

      <ul
        ref="scrollableArea"
        class="nav nav-pills nav-fill nav-market flex-nowrap"
      >
        <li
          v-for="(item, index) in marketType"
          :key="index"
          @click="() => (currentItem = index)"
          class="nav-item"
        >
          <button class="nav-link" :class="{ active: currentItem === index }">
            {{ item.name }}
          </button>
        </li>
      </ul>

      <div class="nav-market-control right" @click="scrollRight">
        <FontAwesomeIcon :icon="faChevronRight" />
      </div>
    </div>
    <ClientOnly>
      <table
        v-if="data"
        class="table table-responsive table-borderless live-market-table"
      >
        <thead>
          <tr>
            <th scope="col">Assets</th>
            <th scope="col" class="text-center">Price</th>
            <th scope="col" class="text-center">Change</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="stock in currentMarketData" :key="stock.symbol">
            <th scope="row">
              <LiveMarketItem
                :title="stock.name"
                :subTitle="stock.symbol"
                :image="stock.image"
              />
            </th>
            <td>
              <NuxtLink to="/register" class="text-decoration-none">
                <LiveMarketCell :value="getValue(stock, 'price')" />
              </NuxtLink>
            </td>
            <td>
              <LiveMarketCell
                :value="getPercentageValue(stock, 'changesPercentage')"
                :trend="getValueTrend(stock, 'changesPercentage')"
                type="percentage"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </ClientOnly>
  </div>
</template>
